<template>
    <div v-if="show">
        <van-overlay :show="show" class="wrapper">
            <van-loading class="load" color="#0094ff" text-color="#0094ff" size="24px" overlay vertical>加载中...</van-loading>
        </van-overlay>
    </div>
    <div v-else class="box">
        <div v-if="list === null || list.length <= 0" class="info">
            <van-image
                class="image"
                width="180px"
                height="104px"
                :src="require('../images/absolutelyEmpty.png')"
            />
            <div class="text">空空如也～快去参加活动领取奖品吧！</div>
        </div>
        <PRIZEINFOCARD v-else class="Card" v-for="item in list" :key="item.id" v-bind="item"/>
    </div>
</template>

<script>
import PRIZEINFOCARD from './prizeInfoCard'
export default {
  props: ['list'],
  components: {
    PRIZEINFOCARD
  },
  data () {
    return {
      show: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.show = false
    }, 200)
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.box{
    // display: table;
    height: 100vh;
    width: 100%;
    background: #F2F2F7;
    overflow: hidden;
    overflow-y: scroll;
    position: relative;
    .info {
        font-size: 13px;
        // display: table-cell;
        // vertical-align: middle;
        text-align: center;
        margin-top: 60%;
        .text {
            margin-top: 32px;
        }
    }
    .Card {
        margin: 10px auto;
    }
}
</style>
